import { Form } from '@anytag/shared-atoms';
import { Template } from './Template';
import { AccountManagerPlanSchema, AccountManagerRequiredPlanSchema } from './schema';
import { AccountManagerPlanFormProps, AccountManagerPlanFormValues } from './types';

export const AccountManagerPlanForm = ({
  onSubmit,
  defaultValues = { accountManagerPlan: '' }
}: AccountManagerPlanFormProps) => (
  <Form.Provider<AccountManagerPlanFormValues>
    className="mt-4"
    onSubmit={onSubmit}
    defaultValues={defaultValues}
    zodSchema={defaultValues?.accountManagerPlan ? AccountManagerRequiredPlanSchema : AccountManagerPlanSchema}
  >
    <Template />
  </Form.Provider>
);

export * from './types';
